import { memo, useEffect, useState } from 'react';
import { DepartmentDTO } from '../../api/api';
import Select, { MenuItem } from '../select/Select';
import DepartmentService from '../../services/DepartmentService';
import { FormControl } from '@mui/material';

interface Props {
  selectDepartment: (d: DepartmentDTO) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  onDepartmentsLoaded?: React.Dispatch<React.SetStateAction<DepartmentDTO[]>>;
  value?: number;
  fullWidth?: boolean;
  error?: boolean;
  required?: boolean;
}

const DepartmentDropdown = (props: Props) => {
  const { selectDepartment, disabled, onDepartmentsLoaded, fullWidth, label, error, value, required } = props;
  const [departments, setDepartments] = useState<DepartmentDTO[]>([]);

  useEffect(() => {
    DepartmentService.GetDepartments().then((res) => {
      setDepartments(res);
      onDepartmentsLoaded && onDepartmentsLoaded(res);
    });
  }, [onDepartmentsLoaded]);

  const handleSelectDepartment = (departmentId: number) => {
    const selectedDepartment = departments.find((d) => d.departmentId === departmentId);
    selectedDepartment && selectDepartment(selectedDepartment);
  };

  return (
    <FormControl fullWidth>
      <Select
        disabled={disabled}
        fullWidth={fullWidth}
        error={error}
        value={value || ''}
        label={label}
        onChange={(e) => handleSelectDepartment(e.target.value as any)}
        required={required}
      >
        {departments.map((d) => (
          <MenuItem value={d.departmentId}>{d.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default memo(DepartmentDropdown);
